







































import {
  computed,
  defineComponent,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonPaymentTypeSelector from '@/components/Setting/CommonPaymentTypeSelector.vue';

import getPaymentAccount from '@/gql/paymentAccount/getPaymentAccount.gql';
import createPaymentAccount from '@/gql/paymentAccount/createPaymentAccount.gql';
import updatePaymentAccount from '@/gql/paymentAccount/updatePaymentAccount.gql';

import useAuth from '@/useAuth';

const CommonFormWithPaymentAccountEditor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonPaymentTypeSelector,
  },
  props: {
    id: { type: [Number, String], default: -1 },
  },
  setup(props, { emit }) {
    const { me } = useAuth();

    const paymentAccount = reactive({
      code: '',
      name: '',
      type: '',
    });

    const { result: paymentAccountResult, loading } = useQuery(getPaymentAccount, computed(() => ({
      id: props.id,
    })), () => ({ fetchPolicy: 'network-only' }));
    const _paymentAccount = useResult(paymentAccountResult, {}, (data) => data.paymentAccount);
    watch(() => paymentAccountResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal && props.id > -1) {
        paymentAccount.code = _paymentAccount.value.code;
        paymentAccount.name = _paymentAccount.value.name;
        paymentAccount.type = _paymentAccount.value.type;
      }
    });

    const refetchQueryList = ['getAccounts'];
    const paymentAccountInput = computed(() => ({
      id: props.id === -1 ? undefined : props.id,
      code: paymentAccount.code,
      name: paymentAccount.name,
      type: paymentAccount.type,
    }));

    const createPaymentAccountMutation = useMutation(createPaymentAccount, () => ({
      variables: {
        input: paymentAccountInput.value,
      },
      refetchQueries: refetchQueryList,
    }));
    const updatePaymentAccountMutation = useMutation(updatePaymentAccount, () => ({
      variables: {
        input: paymentAccountInput.value,
      },
      refetchQueries: refetchQueryList,
    }));
    const confirmModal = ref(null);
    createPaymentAccountMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    updatePaymentAccountMutation.onDone(() => {
      emit('done');
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
    });
    const errorModal = ref(null);
    createPaymentAccountMutation.onError(() => {
      (errorModal.value as any).compose();
    });
    updatePaymentAccountMutation.onError(() => {
      emit('error');
      (errorModal.value as any).compose();
    });

    const computedMutation = computed(() => {
      if (props.id !== -1) return updatePaymentAccountMutation;
      return createPaymentAccountMutation;
    });

    return {
      paymentAccount,

      computedMutation,

      confirmModal,
      errorModal,
    };
  },
});

export default CommonFormWithPaymentAccountEditor;
